import { Injectable } from '@angular/core';

export interface ContextMenuRequest {
    target: Element;
    event: MouseEvent | KeyboardEvent;
    trigger: 'mouse' | 'keyboard';
}

export interface ContextMenuAction<T = unknown> extends ContextMenuRequest {
    context: T;
}

export interface ContextMenuResolver<T = unknown> {
    (request: ContextMenuRequest): T | null;
}

/** Context belongs to the opening container, even when its menu is in an overlay. */
@Injectable()
export class ContextMenuScope {
    action?: ContextMenuAction;
}

/** Only one of the reusable context menus may be open at a time. */
@Injectable({ providedIn: 'root' })
export class ContextMenuService {
    private active?: { owner: object; close: () => void };

    activate(owner: object, close: () => void): void {
        this.active?.close();
        this.active = { owner, close };
    }

    release(owner: object): void {
        if (this.active?.owner === owner) this.active = undefined;
    }
}
